import { FilesMutationTypes } from './mutation_types'
import { FilesState, WatermarkedDialogData } from './state'

export const mutations = {
  [FilesMutationTypes.SET_FILE_PENDING](state: FilesState, value: number) {
    state.filePendingIds.push(value)
  },
  [FilesMutationTypes.REMOVE_FILE_PENDING](state: FilesState, index: number) {
    state.filePendingIds.splice(index, 1)
  },
  [FilesMutationTypes.SET_FILE_ERROR](state: FilesState, value: string | null) {
    state.fileError = value
  },
  [FilesMutationTypes.SET_WATERMARKED_FILE_PENDING](
    state: FilesState,
    { fileId, data, identifier }: { fileId: number, data: { startPage: number, endPage: number }, identifier: string },
  ) {
    for (let page = data.startPage; page <= data.endPage; page++) {
      state.watermarkedFilePendingPages.push({
        fileId,
        page,
        identifier,
      })
    }
  },
  [FilesMutationTypes.REMOVE_WATERMARKED_FILE_PENDING](state: FilesState, identifier: string) {
    state.watermarkedFilePendingPages = state.watermarkedFilePendingPages.filter(o => o.identifier !== identifier)
  },
  [FilesMutationTypes.SET_WATERMARKED_FILE](
    state: FilesState,
    value: { totalNbPages: number, startPage: number, endPage: number, pngImages: string[] },
  ) {
    state.watermarkedFile.totalNbPages = value.totalNbPages
    const requestedPages = Array(value.endPage - value.startPage + 1).fill(0).map((_, idx) => value.startPage + idx)
    for (let i = 0; i < requestedPages.length; i++) {
      const pageExist = state.watermarkedFile.pages.findIndex(p => p.page === requestedPages[i])
      if (pageExist >= 0) {
        state.watermarkedFile.pages[pageExist].pageB64 = value.pngImages[i]
      } else {
        state.watermarkedFile.pages.push({
          page: requestedPages[i],
          pageB64: value.pngImages[i],
        })
      }
    }
  },
  [FilesMutationTypes.SET_WATERMARKED_FILE_ERROR](state: FilesState, value: string | null) {
    state.watermarkedFileError = value
  },
  [FilesMutationTypes.RESET_WATERMARKED_FILE_WITH_FILE_ID](state: FilesState, fileId: number) {
    state.watermarkedFile = {
      fileId: fileId,
      totalNbPages: 0,
      pages: [],
    }
  },
  [FilesMutationTypes.RESET_WATERMARKED_FILE](state: FilesState) {
    state.watermarkedFile = {
      fileId: null,
      totalNbPages: 0,
      pages: [],
    }
  },
  [FilesMutationTypes.SET_WATERMARKED_DIALOG_DATA](
    state: FilesState,
    { file, isOpen }: WatermarkedDialogData,
  ) {
    state.watermarkedDialogData = {
      file,
      isOpen,
    }
  },
  [FilesMutationTypes.RESET_WATERMARKED_DIALOG_DATA](state: FilesState) {
    state.watermarkedDialogData = {
      file: null,
      isOpen: false,
    }
  },
  [FilesMutationTypes.SET_WATERMARKED_REQUEST_PENDING](state: FilesState, request: any) {
    state.watermarkedRequestPending.push(request)
  },
  [FilesMutationTypes.REMOVE_WATERMARKED_REQUEST_PENDING](state: FilesState, identifier: string) {
    const index = state.watermarkedRequestPending.findIndex((r: any) => r.identifier === identifier)
    if (index >= 0) {
      state.watermarkedRequestPending.splice(index, 1)
    }
  },
}
